import { useContext } from 'react'
import { ColorSchemeContext, type ColorSchemeContextData } from './colorSchemeContext.js'

export const useColorScheme = (): ColorSchemeContextData => useContext(ColorSchemeContext)
